<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Campaigns</h1>

		<div class="padding-top">
			<Group class="margin-top" title="Create campaign">

				<!-- Mode -->
				<div class="input-row small-margin-bottom">
					<span class="label">Mode</span>
					<select v-model="create.mode">
						<option value="auto-apply-discount-code">Auto-apply discount code</option>
					</select>
				</div>

				<!-- Discount code -->
				<div class="input-row small-margin-bottom" v-show="create.mode == 'auto-apply-discount-code'">
					<span class="label">Discount code</span>
					<input type="text" v-model="create.discount_code" />
				</div>

				<!-- Period -->
				<div class="input-row small-margin-bottom">
					<span class="label">Period</span>
					<div>
						<input type="text" v-model="create.start_at" />
						-
						<input type="text" v-model="create.end_at" />
					</div>
				</div>

				<!-- Button -->
				<div>
					<button v-on:click="createCampaign()" :disabled="saving">Create</button>
				</div>

			</Group>

			<Group title="Campaigns" class="margin-top">
				<Table :columns="columns" :rows="campaigns" />
			</Group>

		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    saving: false,
    create: {
      mode: '',
      discount_code: '',
      start_at: '',
      end_at: ''
    },
    campaigns: [],
    columns: {
      id: {},
      type: {},
      start_at: {},
      end_at: {},
      discount_code: {}
    }
  }),
  methods: {
    load () {
      Vue.$api.get('/campaigns', this.create, {
        loader: toggle => this.loading = toggle,
        callback: data => this.campaigns = data
      })
    },
    createCampaign () {
      Vue.$api.post('/campaign', this.create, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
